export class QueriesModel {
  id: number;
  respuestaId: number;
  comentario: string;
  estadoConsulta: string;
  motivoId: number;
  motivo: string;
  nombreOperador: string;
  fecha: Date;
}
